exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".petit-size{font-size:1em;font-weight:700}thead{background-color:#78b943}thead th,thead th i{color:#fff!important}.theme--light.v-subheader{font-size:1.3em;color:#000}.v-pagination{-ms-flex-wrap:wrap;flex-wrap:wrap}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0cf5a875","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/pages/events/create-3.vue
// module id = 7l2s
// module chunks = 1